
export const print = (() => {

    const printBtn = document.getElementById("tools-print");

    if (!printBtn) return;

    printBtn.addEventListener("click", function () {
            window.print();
    });

})();
